import { render, staticRenderFns } from "./faceDialog.vue?vue&type=template&id=476ca70a"
import script from "./faceDialog.vue?vue&type=script&lang=js"
export * from "./faceDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports